/* @flow */

import React from 'react';
import { canDownloadEntities } from 'containers/decorators';
import DownloadDropdown from 'components/DownloadDropdown';

export type ReadGroupsQCMetricsDownloadContainerType = {
  downloadSingleQCMetric: () => {},
  downloadAllQCMetric: () => {},
  downloadAll: boolean,
  readGroupQCMetric: any,
  marginOffset: any
}

function ReadGroupsQCMetricsDownloadContainer({
  downloadSingleQCMetric,
  downloadAllQCMetric,
  downloadAll,
  readGroupQCMetric,
  marginOffset
}: ReadGroupsQCMetricsDownloadContainerType): React.Element {
  return (
    <DownloadDropdown
      marginOffset={ marginOffset }
      download={
        format => {
          if (downloadAll) {
            downloadAllQCMetric(format);
          } else downloadSingleQCMetric(readGroupQCMetric, format);
        }
      }
      formats={[`tsv`, `json`]}
    >
      Scientific Pre-Alignment QC Report
    </DownloadDropdown>
  );
}

export default canDownloadEntities(ReadGroupsQCMetricsDownloadContainer);
